import { Navigate } from 'react-router-dom'
import { useFeatures } from './use-features'

/**
 * Wraps a page component and redirects to /dashboard if the feature flag is
 * explicitly set to false. Flags are opt-out: undefined (not yet set) is treated
 * as enabled so features loads.
 */
export const FeatureGate = ({ feature, children }) => {
  const { features } = useFeatures()
  if (features[feature] === false) return <Navigate to="/dashboard" replace />
  return children
}
